import { render, staticRenderFns } from "./Occur.vue?vue&type=template&id=6ef7eea7&"
import script from "./Occur.vue?vue&type=script&lang=ts&"
export * from "./Occur.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports